import { postRequest } from 'utils/requests';

import { parsEventCode } from 'utils/common';

const trackingEvent = (eventCode, mixpanel, username) => {
  const url = `/api/interface_event/`;
  const REQ_BODY = {
    event: parsEventCode(eventCode)
  };

  postRequest(url, REQ_BODY)
    .then(() => {})
    .catch(err => {
      console.log(err);
    });
  if (mixpanel) {
    if (username) {
      mixpanel.track(parsEventCode(eventCode));
    } else {
      mixpanel.track(`${parsEventCode(eventCode)} (User - ${username})`);
    }
  }
};

export default trackingEvent;
